<template>
  <div class="login-container">
    <el-form :model="form" label-width="auto" style="max-width: 600px"  ref="userForm">
    <el-form-item label="Username："
      prop="username"
      :rules="[{ required: true, message: 'Please fill in this field.' }]">
      <el-input v-model="form.username" />
    </el-form-item>
    <el-form-item label="Password："
      prop="password"
      :rules="[{ required: true, message: 'Please fill in this field.' }]">
      <el-input v-model="form.password" type="password"/>
    </el-form-item>
  
    
    <el-form-item label="Role："
      prop="isAdmin"
      :rules="[{ required: true, message: 'Please choose.' }]">
      <el-radio-group v-model="form.isAdmin">
        <el-radio value="admin">Admin</el-radio>
        <el-radio value="user">User</el-radio>
      </el-radio-group>
    </el-form-item>
   
    <el-form-item>
      <el-button type="primary" @click="handleLogin">Login</el-button>
      <el-button  type="primary"  @click="goToRegister">Register</el-button>
      <el-button  type="primary"  @click="openForgotPasswordDialog">Forgot Password</el-button>
    </el-form-item>
  </el-form> 
  </div>
</template>

<script>
import { 
  ref,
  reactive, 
  getCurrentInstance
} from 'vue'

import { ElMessage } from 'element-plus'

import axios from 'axios';
import router from '@/router';
import store from "@/store";

export default {
  setup() {
    const username = ref('');
    const password = ref('');
    const isAdmin = ref('');

    const { proxy } = getCurrentInstance();

    const form = reactive({
      username: '',
      password: '',
      isAdmin: '',
    });

    const handleLogin = async () => {

      proxy.$refs.userForm.validate(async (valid) => {

        if(valid){
          const response = await axios.post("/api/login", {
            username: form.username,
            password: form.password,
            userRole: form.isAdmin,
          });
          let user = response.data; // 假设返回的用户信息在 response.data 中
          console.log("请求: ",user);
          if (user.code === "200") {//登陆成功
            store.dispatch('login', user); // 将用户信息存储到 Vuex
            console.log("store.user", store.getters.user.data)//这里是如何取出vuex中保存的对象信息
            
            if(user.data.userRole === 'admin'){
              console.log('管理员登录成功');
              router.push('/admin'); // 登录成功后跳转到管理员页面
            }else{
              router.push('/');
            }


          }else {
            ElMessage({
            showClose: true,
            message: user.msg,
            type: "warning",
          });
          }
        }


      //   if(valid){
      //      //发送请求
      // if(form.isAdmin === 'admin'){
      //   if(form.username === 'admin' && form.password === 'admin'){
      //     console.log('管理员登录成功');
      //     router.push('/admin'); // 登录成功后跳转到管理员页面
      //   }else{
      //     console.error('管理员登录失败');
      //     return;
      //   }
      // }else{
  //   const response = await axios.post("/login", {
      //       username: form.username,
      //       password: form.password,
      //     });
      //     let user = response.data; // 假设返回的用户信息在 response.data 中
      //     console.log(user);
      //     if (user.code === "200") {//登陆成功
      //       store.dispatch('login', user); // 将用户信息存储到 Vuex
      //       console.log("store.user", store.getters.user.data)//这里是如何取出vuex中保存的对象信息
      //       router.push('/'); // 跳转到主页面或其他适当页面
      //     }else {
      //       ElMessage({
      //       showClose: true,
      //       message: user.msg,
      //       type: "warning",
      //     });
      //     }
      // }
      //   }else{
      //     ElMessage({
      //       showClose: true,
      //       message: "请输入正确的内容",
      //       type: "error",
      //     });
      //   }
      // });
      console.log("参数",form)


     



      // try {
      //   let user;
      //   if (isAdmin.value === 'admin') {
      //     if (username.value === 'admin' && password.value === 'admin') {
      //       user = {username: 'admin', role: 'admin'}; // 示例用户信息
      //       console.log('管理员登录成功');
      //       router.push('/admin'); // 登录成功后跳转到管理员页面
      //     } else {
      //       console.error('管理员登录失败');
      //       return;
      //     }
      //   } else {
  //     const response = await axios.post(`/login?username=${username.value}&password=${password.value}`, {
      //       username: username.value,
      //       password: password.value,
      //     });
      //     user = response.data; // 假设返回的用户信息在 response.data 中
      //     console.log(user);
      //     if (user.code === "200") {//登陆成功
      //       store.dispatch('login', user); // 将用户信息存储到 Vuex
      //       console.log("store.user", store.getters.user.data)//这里是如何取出vuex中保存的对象信息
      //       router.push('/'); // 跳转到主页面或其他适当页面
      //     }else {
      //       alert(user.msg)
      //     }
      //   }
      // } catch (error) {
      //   console.error('Error:', error);
      //   alert(response.data.data)
      // }
    });}

    //跳转到注册
    const goToRegister = () => {
      router.push('/register');
    };

    //跳转到忘记密码
    const openForgotPasswordDialog = () => {
      router.push('/forgotPassword');
    };

    return {
     
      handleLogin,
      goToRegister,
      openForgotPasswordDialog,
      form
    };
  }
};
</script>


<style>
.checkbox-login > div {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  margin-bottom: 10px; /* 每行之间的间隔 */
}

/* 确保标签和复选框在同一行 */
.checkbox-container {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
}

.login-container {
  display: flex;
  justify-content: center; /* 使整个容器居中 */
  align-items: center; /* 使整个容器垂直居中 */
  /*background-color: #f0f0f0;  设置背景颜色为浅灰色 */
  padding: 20px; /* 添加内边距 */
  border-radius: 8px; /* 添加圆角 */

}

/* 登录表单 */
.login-container form {
  display: flex;
  flex-direction: column; /* 垂直排列表单内的元素 */
  align-items: center; /* 水平居中表单内的所有元素 */
  width: 100%;
  max-width: 66%; /* 设置表单最大宽度 */
  background-color: #fff; /* 表单背景颜色为白色 */
  padding: 20px;
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}


.login-container form button:hover {
  background-color: #0056b3; /* 按钮悬停背景颜色 */
}

</style>
